export default "/unicommerce.afb66b33-4d3b12.png";